import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { getProjectProposalsReviewStatus } from 'apis/dashboard.api';

const useGetProjectProposalsReviewStatus = (params, conds) => {
  const { data: projectProposalsReviewStatus, ...rest } = useQuery(
    ['projectProposalsReviewStatus', params],
    () => getProjectProposalsReviewStatus(params),
    {
      ...conds,
    }
  );

  const data = useMemo(
    () => projectProposalsReviewStatus?.data?.data ?? {},
    [projectProposalsReviewStatus]
  );

  return {
    data,
    ...rest,
  };
};

export default useGetProjectProposalsReviewStatus;
